import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { OpEnum } from '../../../shared/enums/op.enum';
import { CountryModel } from '../../../shared/models/abre-cuentas.model';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';

@Component({
  selector: 'app-form-nationality',
  templateUrl: './form-nationality.component.html',
  styleUrls: ['./form-nationality.component.scss'],
})
export class FormNationalityComponent implements OnInit {
  formGroup: FormGroup;
  options: any[];
  selectedCountry: CountryModel;
  emptyCountry: CountryModel = new CountryModel();
  identNumber;

  constructor(
    public copyService: CopyService,
    private formBuilder: FormBuilder,
    private headerService: HeaderService,
    private navigationService: NavigationService,
    private abreCuentasService: AbreCuentasService,
    private parametersService: ParametersService) {
    this.headerService.show(true, true, true);
    this.formGroup = this.formBuilder.group({});
  }

  ngOnInit() {
    this.formGroup = new FormGroup({
      'input-value-identNumber': new FormControl('',
        [Validators.required, Validators.minLength(4), Validators.maxLength(15), Validators.pattern(new RegExp(/^[a-zA-Z0-9-]+$/))]),
    });
    this.options = this.parametersService.getSetting(OpEnum.COUNTRY_LIST);
    const selectedCountry = this.abreCuentasService.getBirthCountry();
    if (!!selectedCountry && selectedCountry.country_code) {
      this.selectedCountry = this.abreCuentasService.getBirthCountry();
    } else {
      this.selectedCountry = { country_code: '', description: '' };
    }
  }

  /**
   * Summary Go to next Step
   */
  next() {
    this.navigationService.nextStep('301');
    this.navigationService.pageLoadTag('ContinuarProcesoPresencialmente', ['pv39', 'pv191', 'pv169']);
    return;
  }

  /**
   * Summary Event for select a option for list selected, and set value in Input
   * @param option
   */
  selectOption(event) {
    if (event.value) {
      this.selectedCountry = this.options.find(e => (e.country_code === event.value.country_code)) || this.emptyCountry;
      this.abreCuentasService.setBirthCountry(this.selectedCountry);
      return;
    }
    this.selectedCountry = { country_code: '', description: '' };
  }

  setValueIdenNumber() {
    this.identNumber = this.formGroup.controls['input-value-identNumber'].value;
  }

  /**
   * Evento de cambio de número de identificación
   *
   * *Summary Identification number entry change event, error validation*
   */
  reactiveInputChangeAddress() {
    const controladdress = this.formGroup.controls['input-value-identNumber'] as FormControl;
    controladdress.setValue(controladdress.value.replace(/[^A-Za-z0-9\s#\-.]/g, '').replace(/\s{2,}/g, ' '));
    this.setValueIdenNumber();
  }

}
